import { styled } from "@mui/material/styles";
import { Box, Typography, Card, Button } from "@mui/material";
import { colors, fonts } from "../../../theme/theme";

export const RootBox = styled(Box)(({ theme }) => ({
  maxWidth: 800,
  marginLeft: "auto",
  marginRight: "auto",
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0),
  },
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(3),
  fontFamily: fonts.gotham,
  color: colors.primary,
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(2),
}));

export const CardTitleRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const BodyText = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.quicksand,
  color: colors.primary,
}));

export const StatsRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(4),
  flexWrap: "wrap",
}));

export const StatBlock = styled(Box)(({ theme }) => ({}));

export const StatLabel = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.quicksand,
  color: colors.textLight,
}));

export const StatValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontFamily: fonts.gotham,
  color: colors.primary,
}));

export const PrimaryButton = styled(Button)(({ theme }) => ({
  fontFamily: fonts.gotham,
  "&:disabled": {
    opacity: 0.7,
  },
}));

export const LoadingBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: 300,
}));

export const ChipContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  flexWrap: "wrap",
  marginBottom: theme.spacing(2),
  minWidth: 0,
  width: "100%",
}));
